export default "__VITE_ASSET__3e033981__"